"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.broadcastDataService = void 0;
var EventBus_1 = require("../tools/EventBus");
var jquery_1 = __importDefault(require("jquery"));
var broadcastData = {
    landscapeImage: null,
    title: null,
    leadtext: null,
    shareTitle: null,
    shareText: null,
    columnist: null
};
var timeoutId;
var pendingRequest;
exports.broadcastDataService = {
    getCurrentData: function () {
        return broadcastData;
    },
};
jquery_1.default.extend(exports.broadcastDataService, new EventBus_1.EventBus());
function isUpdate(data) {
    return (broadcastData.title != data.currentItem.title
        || broadcastData.landscapeImage != data.currentItem.landscapeImage
        || broadcastData.leadtext != data.currentItem.leadtext);
}
function fetchBroadcastData() {
    pendingRequest = jquery_1.default.ajax({
        url: "/nuopbnrjsonp",
        cache: false,
        method: 'GET',
        dataType: 'jsonp',
        contentType: "application/json",
        context: this
    }).done(setBroadcastData);
    timeoutId = setTimeout(fetchBroadcastData, 60000);
}
function setBroadcastData(data) {
    if (isUpdate(data)) {
        broadcastData.landscapeImage = data.currentItem.landscapeImage;
        broadcastData.title = data.currentItem.title;
        broadcastData.leadtext = data.currentItem.leadtext;
        broadcastData.shareTitle = data.currentItem.shareTitle;
        broadcastData.shareText = data.currentItem.shareText;
        broadcastData.columnist = data.currentItem.columnist;
        exports.broadcastDataService.notify('broadcastDataService.update', jquery_1.default.extend({}, broadcastData));
    }
    pendingRequest = null;
}
